import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "./Dashboard/Header/Header";
import SideNav from "./Dashboard/SideNav/SideNav";
import React, { useState } from 'react';
import { useAuth } from "../../Utils/AuthProvider";


const Admin = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const location = useLocation();
    const { user } = useAuth();
    const storedToken =
        sessionStorage.getItem("adminToken") ||
        localStorage.getItem("adminToken");
    const isAuthenticated = Boolean(user?.token || storedToken);
    const isAdminLoginPage = location.pathname === "/admin/administrator";

    const handleToggleClick = () => {
        setIsExpanded(prev => !prev);
    };

    if (!isAuthenticated) {
        if (isAdminLoginPage) {
            return <Outlet />;
        }

        return <Navigate to="/admin/administrator" replace state={{ from: location }} />;
    }

    if (location.pathname === "/admin" || isAdminLoginPage) {
        return <Navigate to="/admin/dashboard" replace />;
    }

    return (
        <>
            <div >
                <Header />
                <div style={{ display: 'flex', minHeight: '100%', paddingTop: '60px' }}>
                    <SideNav isExpanded={isExpanded} onToggle={handleToggleClick} />
                    <div style={{ marginLeft: isExpanded ? '200px' : '60px', flexGrow: 1, transition: 'margin-left 0.3s' }}>
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    )
};

export default Admin;
